import request from "@/utils/axios";

// /sov/brand/aggMonth
export function getSovBrandAggMonth(params) {
  return request.get("/sov/brand/aggMonth", params);
}
